import React, { Component } from "react";
import Banner from "../../components/common/Banner";
import Header from "../../components/common/Header";
import Footer from "../../components/common/Footer";
import ExploreSidebar from "./components/ExploreSidebar";

export default class ExploreVicePrincipal extends Component {
  render() {
    return (
      <div>
        {/* Header */}
        <Header />

        {/* Banner */}
        <Banner title="Vice Principal" image="banners/banner-explore.jpg" />

        {/* Content */}
        <div className="sidebar ttm-sidebar ttm-bgcolor-white clearfix">
          <div className="container-xl">
            <div className="row">
              <div className="col-lg-9 content-area order-lg-2">
                <div className="section-title with-desc text-left clearfix">
                  <div className="title-header">
                    <h3 className="title">Vice Principal</h3>
                  </div>
                </div>

                <div className="ttm-service-single-content-area">
                  <section className="ttm-row team-details-section clearfix">
                    <div className="container-xl">
                      <div className="row">
                        {/* Photo Section */}
                        <div className="col-lg-4" style={{ margin: "auto" }}>
                          <div className="ttm-featured-wrapper">
                            <div className="featured-thumbnail text-center">
                              <img
                                src={
                                  process.env.PUBLIC_URL +
                                  `/assets/images/explore/Picture.png`
                                }
                                alt="Dr. Asha T"
                                className="img-fluid"
                              />
                            </div>
                          </div>
                        </div>

                        {/* Content Section */}
                        <div className="col-lg-8" style={{ margin: "auto" }}>
                          <div className="ttm-team-member-content shadow-box res-991-mt-30">
                            <div className="ttm-team-member-single-list">
                              <h2 className="ttm-team-member-single-title">
                                Dr. Asha T
                              </h2>
                              <span className="ttm-team-member-single-position">
                                B.E., M.E., Ph.D, LMISTE, MIE
                              </span>
                              <hr />

                              <p>
                                Aiming to foster the development of the
                                Institution in terms of Education and
                                Employability in order to compete with global
                                standards.
                              </p>

                              <p>
                                Dr. Asha T has completed her B.E and M.E. in
                                Computer Science and Engineering from Bangalore
                                University. She was awarded Ph.D in Computer and
                                Information Sciences from VTU, Belgaum in the
                                year 2012 for her thesis titled: “Novel soft
                                computing approaches for the identification of
                                Tuberculosis”. She has 30 years of teaching
                                experience and 57 research publications to her
                                credit in peer reviewed international journals
                                and conferences. She is guiding 6 doctoral
                                students and 04 have been awarded.
                              </p>

                              <p>
                                She has been recognized with “Dr. APJ Abdul
                                Kalam Life Time National Achievement Award” for
                                her achievements in the field of teaching,
                                research and publication by the International
                                Institute for Social and Economic Reforms. Her
                                research interests include Data Mining, Medical
                                Informatics, Machine Learning, Big Data and
                                Image Processing.
                              </p>

                              <p>
                                <strong>Weblink:</strong>{" "}
                                <a
                                  href="https://sites.google.com/site/ashatbitcse"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  https://sites.google.com/site/ashatbitcse
                                </a>
                              </p>
                            </div>
                          </div>
                        </div>

                        {/* Additional Message / Vision */}
                        <div className="col-lg-12 paddingtop-2">
                          <p>
                            As Vice Principal of Bangalore Institute of
                            Technology, Dr. Asha T is committed to academic
                            excellence, research innovation, and holistic
                            student development to meet global standards.
                          </p>
                        </div>
                      </div>
                    </div>
                  </section>
                </div>
              </div>

              {/* Sidebar */}
              <div className="col-lg-3 widget-area">
                <ExploreSidebar />
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <Footer />
      </div>
    );
  }
}
